<template>
  <div class="presenza-mobile mobile_customize col-xs-24" v-loading="loading">

    <section v-show="this.showCalendar">
      <div class="elemento row row-custom">
        <div class="col-2 no-padding"></div>
        <div class="mobile-title col-20 no-padding">{{ $t('presenze.title') }}</div>
        <div class="col-2 no-padding" style="padding-top: 10px;">
          <el-tooltip placement="bottom" popper-class="popover-mobile" effect="light">
            <template slot="content">
              <div @click="stampaPres()">
                <span>{{ $t('btn.print') }}</span>
              </div>
              <div @click="attPred()">
                <span>{{ $t('btn.defActivity') }}</span>
              </div>
            </template>

            <icon class="pointer action" name="riv-more" scale="1.5"></icon>
          </el-tooltip>
        </div>
      </div>
      <div class="elemento row row-custom">
        <div class="col-24 no-padding select-wrapper">
          <select v-model="searchFilter.employee" @change="changeUser()">
            <option v-for="(delega) in deleghe" :value="delega.valore" :key="delega.descrizione">{{ delega.descrizione
              }}
            </option>
          </select>
        </div>
      </div>

      <div class="elemento row row-custom">
        <div class="col-24 no-padding">
          <div class="box" :style="{ height: (tableHeight - 20) + 'px' }">
            <!--<div class="action">
              <span @click="today">today</span>
            </div>
            <span @click="goToNuovaRichiesta">news</span>
            <span @click="changeView('L')">list</span>
            <span @click="changeView('M')">month</span>-->
            <FullCalendar :selectable="true" defaultView="dayGridMonth" :header="{
              left: 'prev',
              center: 'title',
              right: 'next'
            }" @datesRender="handleMonthChange" :plugins="calendarPlugins" :eventRender="eventRender"
              :events="giorniCalendar" @dateClick="dateClick" @select="select" :selectLongPressDelay="0"
              ref="fullCalendar" :locale=config.locale :firstDay=config.firstDay />
          </div>
        </div>
      </div>
      <div class="elemento row row-custom">
        <div class="col-24" style="padding-left: 5px ;padding-right: 0;">
          <el-button class="mobile-el-button primary" style="margin-top: 10px !important;" type="primary"
            v-if="mese.chiuso === 'NO' && mese.registra === 'SI'" @click="saveMese">{{ $t('btn.regPresence') }}
          </el-button>
          <el-button class="mobile-el-button primary" style="margin-top: 10px !important;" type="primary"
            v-if="mese.chiuso === 'NO' && mese.registra === 'NO'" @click="chiusuraMese">{{ $t('btn.closeMonth') }}
          </el-button>
          <div v-if="mese.chiuso === 'SI'">
            <span>{{ $t('presenze.chiuso') }}</span>
          </div>
        </div>
      </div>
    </section>

    <section v-show="!this.showCalendar" v-loading="loading_Day" style="height: 500px;">
      <div class="elemento row row-custom">
        <div class="col-24 el-form_mobile">
          <div class="el-form-header row row-custom">
            <div class="el-form-action col-2 no-padding">
              <icon name="riv-arrow2" scale="1.2" flip="horizontal" @click.native="closeDay()"></icon>
            </div>
            <div class="el-form-title col-20 no-padding">
              {{ getTitleModal() }}
            </div>
            <div class="col-2 no-padding" style="padding-top: 10px;">
              <el-tooltip placement="bottom" popper-class="popover-mobile" effect="light">
                <template slot="content">
                  <div @click="copiaGiorno()">
                    <span>{{ $t('btn.copy') }}</span>
                  </div>
                  <div @click="incollaGiorno()" v-if="attCopiata.length > 0">
                    <span>{{ $t('btn.paste') }}</span>
                  </div>
                </template>

                <icon class="pointer action" name="riv-more" scale="1.5"></icon>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="elemento row row-custom">
        <div class="col-24 no-padding day-body" :class="isDisabled() ? 'min' : 'max'">
          <el-carousel arrow="never" class="el-carousel-presenze" :autoplay="false" indicator-position="outside"
            trigger="click" v-if="modalGiorno.numRows > 0" :class="isDisabled() ? 'min' : 'max'">
            <el-carousel-item v-for="(row, index) in modalGiorno.numRows" :key="index" class="el-form_mobile">

              <el-form class="el-form-body">

                <div class="elemento row row-custom">
                  <div class="el-form-label col-24 no-padding">{{ $t('presenze.hours') }}</div>
                  <div class="el-form-value col-24 no-padding" v-if="isDisabled()">{{ modalGiorno.righe[index].ore }}
                  </div>
                  <div class="el-form-input col-12 no-padding" v-if="!isDisabled()">
                    <div class="select-wrapper">
                      <select v-model="modalGiorno.righe[index].ore" @change="changeOre(modalGiorno.righe[index])">
                        <option v-for="(item) in orario" :value="item.valore" :key="item.valore">{{ item.descrizione }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12" style="padding-left: 0;padding-right: 5px;" v-if="!isDisabled()">
                    <span @click="addAttività(modalGiorno.righe[index])">{{ $t('btn.addActivity') }}</span>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="el-form-label col-24 no-padding">{{ $t('presenze.causal') }}</div>
                  <div class="el-form-value col-12 no-padding" v-if="isDisabled()">{{ modalGiorno.righe[index].causale
                    }}
                  </div>
                  <div class="el-form-input col-24 no-padding" v-else>
                    <div class="select-wrapper">
                      <select v-model="modalGiorno.righe[index].causale"
                        @change="changeCausale(modalGiorno.righe[index])">
                        <option v-for="(item) in causali" :value="item.valore" :key="item.valore">{{ item.descrizione }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="el-form-label col-24 no-padding">{{ $t('presenze.place') }}</div>
                  <div class="el-form-value col-12 no-padding" v-if="isDisabled()">{{ modalGiorno.righe[index].descrLoc
                    }}
                  </div>
                  <div class="el-form-input col-24 no-padding" v-else>
                    <div class="input-wrapper" v-if="showLocCustom(modalGiorno.righe[index])">
                      <el-input v-model="modalGiorno.righe[index].descrLoc">
                        <i slot="prepend" @click="clearLoc(modalGiorno.righe[index], 'G')"
                          class="el-icon-arrow-left"></i>
                      </el-input>
                    </div>
                    <div class="select-wrapper" v-else>
                      <select v-model="modalGiorno.righe[index].localita">
                        <option v-for="(item) in località" :value="item.valore" :key="item.valore">{{ item.descrizione
                          }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="el-form-label col-24 no-padding">{{ $t('presenze.company') }}</div>
                  <div class="el-form-value col-12 no-padding" v-if="isDisabled()">{{ modalGiorno.righe[index].descrAzi
                    }}
                  </div>
                  <div class="el-form-input col-24 no-padding" v-else>
                    <div class="select-wrapper">
                      <select v-model="modalGiorno.righe[index].azienda"
                        @change="getCdc(modalGiorno.righe[index].azienda)">
                        <option v-for="(item) in aziende" :value="item.valore" :key="item.valore">{{ item.descrizione }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="el-form-label col-24 no-padding">{{ $t('presenze.officeDepartment') }}</div>
                  <div class="el-form-value col-12 no-padding" v-if="isDisabled()">{{ modalGiorno.righe[index].desCdc }}
                  </div>
                  <div class="el-form-input col-24 no-padding" v-else>
                    <div class="select-wrapper">
                      <select v-model="modalGiorno.righe[index].cdc">
                        <option v-for="(item) in cdc[modalGiorno.righe[index].azienda]" :value="item.valore"
                          :key="item.valore">{{ item.descrizione }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="elemento row row-custom">
                  <div class="el-form-label col-24 no-padding">{{ $t('presenze.busyness') }}</div>
                  <div class="el-form-value col-12 no-padding" v-if="isDisabled()">{{
                    modalGiorno.righe[index].intervento }}
                  </div>
                  <div class="el-form-input col-24 no-padding" v-else>
                    <div class="input-wrapper">
                      <input type="text" maxlength="100" v-model="modalGiorno.righe[index].intervento" />
                    </div>
                  </div>
                </div>
                <div class="elemento row row-custom" v-if="mese.auto === 'SI' && modalGiorno.tipologia === 'Giorno'">
                  <div class="el-form-label col-24 no-padding">{{ $t('presenze.km') }}</div>
                  <div class="el-form-value col-12 no-padding" v-if="isDisabled()">{{ modalGiorno.righe[index].km }}
                  </div>
                  <div class="el-form-input col-24 no-padding" v-else>
                    <div class="input-wrapper">
                      <input type="number" v-model="modalGiorno.righe[index].km" />
                    </div>
                  </div>
                </div>
              </el-form>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="elemento row row-custom" v-if="!isDisabled()">
        <div class="col-12" style="padding-left: 0;padding-right: 5px;">
          <el-button class="mobile-el-button secondary" style="margin-top: 10px !important;" @click="closeDay()">{{
            $t('btn.annulla') }}
          </el-button>
        </div>
        <div class="col-12" style="padding-left: 5px ;padding-right: 0;">
          <el-button class="mobile-el-button primary" style="margin-top: 10px !important;" type="primary"
            v-if="modalGiorno.tipologia === 'Giorno'" @click="saveGiorno">{{ $t('btn.conferma') }}
          </el-button>
          <el-button class="mobile-el-button primary" style="margin-top: 10px !important;" type="primary" v-else
            @click="saveAttPred">{{ $t('btn.conferma') }}
          </el-button>
        </div>
      </div>

    </section>

  </div>
</template>

<script>
import { bus } from '@/components/Bus.js'
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import moment from 'moment'

export default {
  name: "PresenzeMobile",
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },
  props: ["tableHeight"],
  data() {
    return {
      calendarPlugins: [dayGridPlugin, listPlugin, interactionPlugin],
      //value: new Date(),
      loading: false,
      loading_Day: false,
      loading_Save: false,
      showCalendar: true,
      firstTimeCalendar: true,
      giorniCalendar: [],
      deleghe: [],
      listAttPred: [],
      causali: [],
      località: [],
      aziende: [],
      cdc: {},
      form: {
      },
      searchFilter: {
        'employee': null,
        // 'currentEmployee': null,
        'data': '',
        'anno': '',
        'mese': '',
        'periodo': '',
        'registra': 'NO'
      },
      mese: {
        cFisc: '',
        chiuso: '',
        auto: '',
        toSave: false,
        registra: 'NO'
      },
      config: {
        locale: this.setLocale(),
        firstDay: 1
      },
      showModal: false,
      modalGiorno: {
        numRows: 0,
        tipologia: '',
        giorno: '',
        mese: '',
        anno: '',
        righe: []
      },
      attCopiata: [],
      orario: [
        { 'valore': '0000', 'descrizione': '00:00' },
        { 'valore': '0030', 'descrizione': '00:30' },
        { 'valore': '0100', 'descrizione': '01:00' },
        { 'valore': '0130', 'descrizione': '01:30' },
        { 'valore': '0200', 'descrizione': '02:00' },
        { 'valore': '0230', 'descrizione': '02:30' },
        { 'valore': '0300', 'descrizione': '03:00' },
        { 'valore': '0330', 'descrizione': '03:30' },
        { 'valore': '0400', 'descrizione': '04:00' },
        { 'valore': '0430', 'descrizione': '04:30' },
        { 'valore': '0500', 'descrizione': '05:00' },
        { 'valore': '0530', 'descrizione': '05:30' },
        { 'valore': '0600', 'descrizione': '06:00' },
        { 'valore': '0630', 'descrizione': '06:30' },
        { 'valore': '0700', 'descrizione': '07:00' },
        { 'valore': '0730', 'descrizione': '07:30' },
        { 'valore': '0800', 'descrizione': '08:00' },
        { 'valore': '0830', 'descrizione': '08:30' },
        { 'valore': '0900', 'descrizione': '09:00' },
        { 'valore': '0930', 'descrizione': '09:30' },
        { 'valore': '1000', 'descrizione': '10:00' },
        { 'valore': '1030', 'descrizione': '10:30' },
        { 'valore': '1100', 'descrizione': '11:00' },
        { 'valore': '1130', 'descrizione': '11:30' },
        { 'valore': '1200', 'descrizione': '12:00' },
        { 'valore': '1230', 'descrizione': '12:30' },
        { 'valore': '1300', 'descrizione': '13:00' },
        { 'valore': '1330', 'descrizione': '13:30' },
        { 'valore': '1400', 'descrizione': '14:00' },
        { 'valore': '1430', 'descrizione': '14:30' },
        { 'valore': '1500', 'descrizione': '15:00' },
        { 'valore': '1530', 'descrizione': '15:30' },
        { 'valore': '1600', 'descrizione': '16:00' }
      ],
    }
  },
  activated: function () {
    bus.$on('changeLanguage', () => {
      this.$nextTick(() => {
        this.$set(this.config, 'locale', this.setLocale())
      })
    })
    this.loading = true
    this.getDeleghe()
  },
  deactivated: function () {
    this.$set(this, 'firstTimeCalendar', true)
    this.$set(this, 'giorniCalendar', [])
    this.$set(this, 'deleghe', [])
    this.$set(this, 'listAttPred', [])
    this.$set(this, 'causali', [])
    this.$set(this, 'località', [])
    this.$set(this, 'aziende', [])
    this.$set(this, 'cdc', {})
    let searchFilter = {
      'employee': '',
      // 'currentEmployee': null,
      'data': '',
      'anno': '',
      'mese': '',
      'periodo': ''
    }
    this.$set(this, 'searchFilter', searchFilter)
    let mese = {
      cFisc: '',
      chiuso: '',
      auto: '',
      toSave: false
    }
    this.$set(this, 'mese', mese)
    let modalGiorno = {
      numRows: 0,
      tipologia: '',
      giorno: '',
      mese: '',
      anno: '',
      righe: []
    }
    this.$set(this, 'modalGiorno', modalGiorno)
    this.$set(this, 'attCopiata', [])
  },
  filters: {
    formatDate: function (date) {
      if (date !== "") {
        return (
          date.substr(6, 2) + "/" + date.substr(4, 2) + "/" + date.substr(0, 4)
        );
      } else {
        return "-";
      }
    }
  },
  methods: {
    handleMonthChange: function (arg) {
      if (this.firstTimeCalendar) {
        this.firstTimeCalendar = false
      } else {
        var currentStart = arg.view.currentStart;
        var check = moment(currentStart, "YYYY/MM/DD");
        var anno = check.format("YYYY");
        var mese = check.format("MM");
        this.searchFilter.anno = anno
        this.searchFilter.mese = mese
        this.calMese(anno, mese)
      }
    },
    today: function () {
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.today()
    },
    changeView: function (type) {
      let calendarApi = this.$refs.fullCalendar.getApi();
      if (type === "L") {
        calendarApi.changeView("listMonth");
        this.richieste = this.richieste.map(function (obj) {
          obj.rendering = "";
          return obj;
        });
      } else {
        calendarApi.changeView("dayGridMonth");
        this.richieste = this.richieste.map(function (obj) {
          obj.rendering = "background";
          return obj;
        });
      }
    },
    dateClick: function (info) {
      let anno = info.dateStr.split('-')[0]
      let mese = info.dateStr.split('-')[1]
      if (anno === this.searchFilter.anno && mese === this.searchFilter.mese) {
        let giorno = info.dateStr.split('-')[2]
        this.sitGiorno(giorno)
        this.showCalendar = false
      }
    },
    closeDay: function () {
      let obj = {
        numRows: 0,
        tipologia: '',
        giorno: '',
        mese: '',
        anno: '',
        righe: []
      }
      this.$set(this, 'modalGiorno', obj)
      this.showCalendar = true
    },
    addAttività: function (giorno) {
      if (giorno.numRows >= 8) return
      let righe = JSON.parse(JSON.stringify(this.modalGiorno.righe))
      let obj = {
        ore: '0000',
        causale: '',
        localita: '',
        descrLoc: '',
        azienda: '',
        cdc: '',
        km: '',
        intervento: '',
      }
      righe.push(obj)
      this.$set(this.modalGiorno, 'righe', righe)
      this.modalGiorno.numRows += 1
    },
    copiaGiorno: function () {
      this.$set(this, 'attCopiata', this.modalGiorno.righe)
    },
    incollaGiorno: function () {
      this.modalGiorno.numRows = 0
      this.$set(this.modalGiorno, 'righe', this.attCopiata)
      this.$set(this.modalGiorno, 'numRows', this.attCopiata.length)
    },
    sitGiorno: function (giorno) {
      this.loading_Day = true

      let codFisc = this.searchFilter.employee
      let anno = this.searchFilter.anno
      let mese = this.searchFilter.mese
      let num = giorno

      this.$set(this.modalGiorno, 'tipologia', 'Giorno')
      this.$set(this.modalGiorno, 'anno', anno)
      this.$set(this.modalGiorno, 'mese', mese)
      this.$set(this.modalGiorno, 'num', num)
      this.$set(this.modalGiorno, 'righe', [])

      let obj = {
        params: {
          'codFisc': codFisc,
          'anno': anno,
          'mese': mese,
          'giorno': giorno
        }
      }
      this.$http.get('presenze/' + this.$store.state.country + '/giorno', obj).then(response => {
        if (response.body.rc === 0) {
          if (response.body.data.length > 0) {
            let righe = []
            // Giorno compilato
            for (let i = 0; i < response.body.data.length; i++) {
              if (response.body.data[i].azienda !== '')
                this.getCdc(response.body.data[i].azienda)
              let obj = {
                ore: response.body.data[i].ore,
                causale: response.body.data[i].causale,
                localita: response.body.data[i].localita,
                descrLoc: response.body.data[i].descrLoc,
                azienda: response.body.data[i].azienda,
                descrAzi: response.body.data[i].descrAzi,
                cdc: response.body.data[i].cdc,
                desCdc: response.body.data[i].desCdc,
                km: response.body.data[i].km,
                intervento: response.body.data[i].intervento
              }
              righe.push(obj)
            }
            this.$set(this.modalGiorno, 'righe', righe)
            this.modalGiorno.numRows = response.body.data.length
          }
        } else {
          if (this.listAttPred.length === 0) {
            // Giorno non compilato e attività predefinità non inserita
            let obj = {
              ore: '8:00',
              causale: '',
              localita: '',
              descrLoc: '',
              azienda: '',
              descrAzi: '',
              cdc: '',
              desCdc: '',
              km: '',
              intervento: '',
            }
            let righe = []
            righe.push(obj)
            this.$set(this.modalGiorno, 'righe', righe)
            this.modalGiorno.numRows = 1
          } else {
            let righe = []
            // Giorno compilato
            for (let i = 0; i < this.listAttPred.length; i++) {
              if (this.listAttPred[i].azienda !== '')
                this.getCdc(this.listAttPred[i].azienda)
              let obj = {
                ore: this.listAttPred[i].ore,
                causale: this.listAttPred[i].causale,
                localita: this.listAttPred[i].localita,
                descrLoc: this.listAttPred[i].descrLoc,
                azienda: this.listAttPred[i].azienda,
                cdc: this.listAttPred[i].cdc,
                km: '0000000',
                intervento: this.listAttPred[i].intervento
              }
              righe.push(obj)
            }
            this.$set(this.modalGiorno, 'righe', righe)
            this.modalGiorno.numRows = this.listAttPred.length
          }
        }
        this.loading_Day = false
        this.modalType = 'sitGiorno'
      })
    },
    saveGiorno: function () {
      let righe = []
      //for (let i = 0; i < this.modalGiorno.numRows; i++) {
      for (let i = 0; i < 8; i++) {
        if (i < this.modalGiorno.numRows && this.modalGiorno.righe[i].ore != '' && this.modalGiorno.righe[i].ore != '0000') {
          let km = this.modalGiorno.righe[i].km === '' ? '0000000' : '0000000' + this.modalGiorno.righe[i].km
          let numRiga = '0' + (i + 1)
          let obj = {
            numRiga: numRiga.slice(numRiga.length - 2, numRiga.length),
            ore: (this.modalGiorno.righe[i].ore != '' ? this.modalGiorno.righe[i].ore : '0000'),
            causale: (this.modalGiorno.righe[i].causale != '' ? this.modalGiorno.righe[i].causale : ''),
            localita: (this.modalGiorno.righe[i].localita != '' ? this.modalGiorno.righe[i].localita : ''),
            descrLoc: this.modalGiorno.righe[i].descrLoc,
            azienda: (this.modalGiorno.righe[i].azienda != '' ? this.modalGiorno.righe[i].azienda : ''),
            cdc: (this.modalGiorno.righe[i].cdc != '' ? this.modalGiorno.righe[i].cdc : ''),
            intervento: this.modalGiorno.righe[i].intervento,
            km: (km.slice((km.length - 7), km.length))
          }
          righe.push(obj)
        } else {
          let numRiga = '0' + (i + 1)
          let obj = {
            numRiga: numRiga.slice(numRiga.length - 2, numRiga.length),
            ore: '0000',
            causale: '',
            localita: '',
            descrLoc: '',
            azienda: '',
            cdc: '',
            intervento: '',
            km: "0000000"
          }
          righe.push(obj)
        }
      }

      let obj = {
        'codFisc': this.searchFilter.employee,
        'anno': this.searchFilter.anno,
        'mese': this.searchFilter.mese,
        'giorno': this.modalGiorno.num,
        'righe': righe
      }
      this.$http.post('presenze/' + this.$store.state.country + '/giorno', obj).then(response => {
        if (response.body.rc === 0) {
          this.closeDay()
          this.calMese(this.searchFilter.anno, this.searchFilter.mese)
        } else {
          for (let i = 0; i < response.body.data.length; i++) {
            this.$message({
              showClose: true,
              message: response.body.data[i].ggErr + ': ' + response.body.data[i].descrErr,
              type: 'error',
              duration: process.env.duration
            })
          }
        }
      })
    },
    saveMese: function () {
      let _this = this
      this.$confirm(this.$i18n.t('presenze.confReg'), this.$i18n.t('presenze.info'), {
        confirmButtonText: this.$i18n.t('btn.regPresence'),
        cancelButtonText: this.$i18n.t('btn.annulla'),
        type: 'info',
        customClass: 'el-message-box-mobile',
        callback: function (action) {
          if (action === 'confirm') {
            let numRec = 0
            let giorni = []
            let obj = {
              codFisc: _this.searchFilter.employee,
              anno: _this.searchFilter.anno,
              mese: _this.searchFilter.mese,
              numRec: numRec,
              giorni: giorni
            }
            _this.$http.post('presenze/' + _this.$store.state.country + '/mese', obj).then(response => {
              if (response.body.rc === 0) {
                _this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'success',
                  duration: process.env.duration
                })
                _this.calMese(_this.searchFilter.anno, _this.searchFilter.mese)
              } else {
                // Messaggio di errore Salvataggio
                _this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
                for (let i = 0; i < response.body.data.length; i++) {
                  if (response.body.data[i].ggErr != undefined) {
                    setTimeout(function (index) {
                      _this.$notify({
                        title: _this.$i18n.t('presenza.msg.errorSaveDay') + parseInt(response.body.data[index].ggErr),
                        message: response.body.data[index].descrErr,
                        type: 'error',
                        duration: process.env.duration
                      })
                    }, 200 * (i + 1), i)
                  }
                }
              }
            })
          }
        }
      })
    },
    chiusuraMese: function () {
      let _this = this
      let anno = _this.searchFilter.anno
      let mese = _this.searchFilter.mese
      this.$confirm(this.$i18n.t('presenze.confCloseMonth'), this.$i18n.t('presenze.info'), {
        confirmButtonText: this.$i18n.t('btn.closeMonth'),
        cancelButtonText: this.$i18n.t('btn.annulla'),
        type: 'info',
        customClass: 'el-message-box-mobile',
        callback: function (action) {
          if (action === 'confirm') {

            let obj = {
              codFisc: _this.searchFilter.employee,
              utente: _this.searchFilter.employee,
              anno: anno,
              mese: mese
            }
            _this.$http.post('presenze/' + _this.$store.state.country + '/chiusMes', obj).then(response => {
              if (response.body.rc === 0) {
                _this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'success',
                  duration: process.env.duration
                })
                _this.calMese(anno, mese)
              } else {
                _this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'warning',
                  duration: process.env.duration
                })
              }
            })
          } /*else {
            _this.$message({
              showClose: true,
              message: this.$i18n.t('presenza.msg.abort'),
              type: 'error',
              duration: process.env.duration
            })
          }*/
        }
      })
    },
    select: function (info) {
    },
    eventRender: function (info) {
      //console.log("eventRender")
      //console.log(info.view.currentStart);
      //info.el.textContent = info.event.title
      info.el.textContent = info.event.extendedProps.num
      if (info.event.extendedProps.stato === "SI") {
        info.el.className += " inserita";
      } else if (info.event.extendedProps.festivo === "SI") {
        info.el.className += " festivo";
      } else if (this.listAttPred.length > 0) {
        info.el.className += " attPred";
      }
    },
    getDeleghe: function () {
      this.$http.get('presenze/' + this.$store.state.country + '/deleghe').then(response => {
        if (response.body.rc === 0) {
          let del = []
          for (var i = 0; i < response.body.data.length; i++) {
            let obj = {}
            obj.valore = response.body.data[i].codFisc
            obj.descrizione = response.body.data[i].cognx + ' ' + response.body.data[i].nomex
            del.push(obj)
          }
          this.deleghe = del
        }
        let findUser = false
        if (this.deleghe.find(o => o.valore === response.body.attrib.codFisc) !== undefined) {
          /*this.searchFilter.employee = {
            'valore': response.body.attrib.codFisc,
            'descrizione': response.body.attrib.cognx + ' ' + response.body.attrib.nomex
          }*/
          this.searchFilter.employee = response.body.attrib.codFisc
          findUser = true
        } else if (this.deleghe.length === 1) {
          /*this.searchFilter.employee = {
            'valore': this.deleghe[0].valore,
            'descrizione': this.deleghe[0].descrizione
          }*/
          this.searchFilter.employee = response.body.data[0].codFisc
          this.changeUser()
        } else if (this.deleghe.length >= 1 && !findUser) {
          this.searchFilter.employee = response.body.data[0].codFisc
          this.changeUser()
        }
        if (findUser) {
          this.changeUser()
        }
        /*this.$watch('activateWatch', function (newVal, oldVal) {
          if (newVal) {
            if (this.delegaUnWatch !== null) this.delegaUnWatch()
            this.delegaUnWatch = this.$watch('searchFilter.employee', function (newValue, oldValue) {
              this.$emit('changeUser')
            })
            this.activateWatch = false
          }
        })
        this.delegaUnWatch = this.$watch('searchFilter.employee', function (newValue, oldValue) {
          this.$emit('changeUser')
        })*/
      })
    },
    changeUser: function () {
      this.getCausale()
      this.getLocalita()
      this.getAzienda()
      this.getPresDef()
    },
    changeOre: function (activity) {
      if (activity.ore === '0000') {
        activity.causale = ''
        activity.localita = ''
        activity.descrLoc = ''
        activity.azienda = ''
        activity.cdc = ''
        activity.km = ''
        activity.intervento = ''
      }
    },
    changeCausale: function (activity) {
      activity.localita = ''
      activity.descrLoc = ''
      activity.azienda = ''
      activity.cdc = ''
      activity.km = ''
      activity.intervento = ''
    },
    getPresDef: function () {
      var obj = {
        params: {
          'codFisc': this.searchFilter.employee
        }
      }
      this.$http.get('presenze/' + this.$store.state.country + '/attPred', obj).then(response => {
        if (response.body.rc === 0) {
          this.listAttPred = response.body.data
        } else {
          this.listAttPred = []
        }
        //this.getAzienda()
        let anno = this.searchFilter.anno === '' ? '0000' : this.searchFilter.anno
        let mese = this.searchFilter.mese === '' ? '00' : this.searchFilter.mese
        this.calMese(anno, mese)
      })
    },
    getCausale: function () {
      this.causali = []
      var obj = {
        params: {
          'codFisc': this.searchFilter.employee,
          'campo': 'CAU'
        }
      }
      this.$http.get('presenze/' + this.$store.state.country + '/tabelle', obj).then(response => {
        if (response.body.rc === 0) {
          this.causali = response.body.data.filter(function (obj) {
            if (obj.seGestibile === 'SI') {
              return obj
            }
          })
        }
      })
    },
    getLocalita: function () {
      this.località = []
      var obj = {
        params: {
          'codFisc': this.searchFilter.employee,
          'campo': 'LOC'
        }
      }
      this.$http.get('presenze/' + this.$store.state.country + '/tabelle', obj).then(response => {
        if (response.body.rc === 0) {
          this.località = response.body.data
        }
      })
    },
    getAzienda: function () {
      this.aziende = []
      var obj = {
        params: {
          'codFisc': this.searchFilter.employee,
          'campo': 'AZR'
        }
      }
      this.$http.get('presenze/' + this.$store.state.country + '/tabelle', obj).then(response => {
        if (response.body.rc === 0) {
          this.aziende = response.body.data
        }
      })
    },
    getCdc: function (azienda) {
      if (this.cdc[azienda]) return
      var obj = {
        params: {
          'codFisc': this.searchFilter.employee,
          'campo': 'CDC',
          'socCdc': azienda
        }
      }
      this.$http.get('presenze/' + this.$store.state.country + '/tabelle', obj).then(response => {
        if (response.body.rc === 0) {
          let obj = JSON.parse(JSON.stringify(this.cdc))
          obj[azienda] = response.body.data
          this.$set(this, 'cdc', obj)
        } else {
          this.$message({
            showClose: true,
            message: 'Non ci sono CE-CO selezionabili per la società ' + azienda + '. Contattare l\'ufficio Amministrativo',
            type: 'error',
            duration: process.env.duration
          })
        }
      })
    },
    calMese: function (anno, mese) {
      this.loading = true
      this.mese.registra = 'NO'
      this.$set(this, 'giorniCalendar', [])
      var obj = {
        params: {
          'codFisc': this.searchFilter.employee,
          'anno': anno,
          'mese': mese
        }
      }
      this.$http.get('presenze/' + this.$store.state.country + '/mese', obj).then(response => {
        if (response.body.rc === 0) {
          this.mese.auto = response.body.attrib.auto
          this.mese.chiuso = response.body.attrib.chiuso
          if (anno === '0000' && mese === '00') {
            var day = moment(response.body.attrib.anno + response.body.attrib.mese + '01', 'YYYYMMDD')
            //this.searchFilter.data = day
            this.searchFilter.anno = response.body.attrib.anno
            this.searchFilter.mese = response.body.attrib.mese
          }
          // MAP PER COMPILARE/MODIFICARE I GIORNI DELMESE
          // this.searchFilter.currentEmployee = response.body.attrib.codFisc
          this.mese.cFisc = response.body.attrib.codFisc
          this.mese.cognx = response.body.attrib.cognx
          this.mese.nomex = response.body.attrib.nomex
          let calendarApi = this.$refs.fullCalendar.getApi();
          calendarApi.gotoDate(response.body.attrib.anno + '-' + response.body.attrib.mese + '-01')
          for (let i = 0; i < response.body.data.length; i++) {
            let giorno = this.searchFilter.anno + "-" + this.searchFilter.mese + "-" + response.body.data[i].num
            if (response.body.data[i].compilato === 'SI') {
              let objCal = {}
              objCal.title = 'INSERITA'
              objCal.start = giorno + "T00:00:00.000Z";
              objCal.end = giorno + "T23:59:00.000Z";
              objCal.allDay = true;
              objCal.rendering = "background";
              objCal.stato = response.body.data[i].compilato
              objCal.festivo = response.body.data[i].festivo
              this.giorniCalendar.push(objCal)
            } else if (response.body.data[i].festivo === 'SI') {
              let objCal = {}
              objCal.title = 'HOLIDAY'
              objCal.start = giorno + "T00:00:00.000Z";
              objCal.end = giorno + "T23:59:00.000Z";
              objCal.allDay = true;
              objCal.rendering = "background";
              objCal.stato = response.body.data[i].compilato
              objCal.festivo = response.body.data[i].festivo
              this.giorniCalendar.push(objCal)
            } else if (this.listAttPred.length > 0) {
              let objCal = {}
              objCal.title = 'ATTPRED'
              objCal.start = giorno + "T00:00:00.000Z";
              objCal.end = giorno + "T23:59:00.000Z";
              objCal.allDay = true;
              objCal.rendering = "background";
              objCal.stato = response.body.data[i].compilato
              objCal.festivo = response.body.data[i].festivo
              this.giorniCalendar.push(objCal)
              this.mese.registra = 'SI'
            } else {
              this.mese.registra = 'SI'
            }
          }
        } else {
          //if (this.deleghe.length === 0) {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
          //}
        }
        this.loading = false
      })
    },
    setLocale: function () {
      let localconf = {
        fr_FR: 'fr',
        it_IT: 'it',
        es_ES: 'es',
        de_DE: 'de',
        en_GB: 'en'
      }
      return localconf[this.$store.state.country]
    },
    getTitleModal: function () {
      if (this.modalGiorno.tipologia === 'Giorno') {
        let day = moment(this.modalGiorno.anno + '-' + this.modalGiorno.mese + '-' + this.modalGiorno.num)
        let value = day.format('dddd') + ' ' + parseInt(this.modalGiorno.num) + ' ' + day.format('MMMM') + ' ' + this.modalGiorno.anno
        return value //this.$i18n.t('presenze.detGio', { day: value})
      } else {
        return this.$i18n.t('presenze.attPred')
      }
    },
    showLocCustom: function (giorno) {
      if (giorno.localita === '') {
        return false
      } else if (giorno.localita === 'E98' || giorno.localita === 'E99') {
        return true
      } else {
        return false
      }
    },
    clearLoc: function (giorno, type) {
      if (type === 'G') {
        giorno.descrLoc = ''
        giorno.localita = ''
      } else {
        giorno.descrLoc = ''
        giorno.localita = ''
      }
    },
    isDisabled: function () {
      if (this.modalGiorno.tipologia === 'Giorno' && this.mese.chiuso === 'SI') {
        return true
      } else {
        return false
      }
    },
    stampaPres: function () {
      let codFisc = this.searchFilter.employee
      let anno = this.searchFilter.anno
      let mese = this.searchFilter.mese
      let tipo = 'presenze'
      let url = ('download/presenze?codFisc=' + codFisc + '&anno=' + anno + '&mese=' + mese + '&tipo=' + tipo + '&country=' + this.$store.state.country + '&token=' + sessionStorage.getItem('token'))
      let win = window.open(process.env.baseUrlSpring + url, '_blank')
      win.focus()
    },
    /* ATTIVITA' PREDEFINITA */
    attPred: function () {
      // ATTIVITA' PREDEFINITA
      this.loading_Day = true

      let codFisc = this.searchFilter.employee
      let anno = this.searchFilter.anno
      let mese = this.searchFilter.mese

      this.$set(this.modalGiorno, 'tipologia', 'AttPred')
      this.$set(this.modalGiorno, 'anno', anno)
      this.$set(this.modalGiorno, 'mese', mese)
      this.$set(this.modalGiorno, 'righe', [])

      for (let i = 0; i < 8; i++) {
        if (this.listAttPred.length > i && this.listAttPred[i].azienda !== '')
          this.getCdc(this.listAttPred[i].azienda)
        let day = {
          ore: (this.listAttPred.length > i ? this.listAttPred[i].ore : ''),
          causale: (this.listAttPred.length > i ? this.listAttPred[i].causale : ''),
          localita: (this.listAttPred.length > i ? this.listAttPred[i].localita : ''),
          descrLoc: (this.listAttPred.length > i ? this.listAttPred[i].descrLoc : ''),
          azienda: (this.listAttPred.length > i ? this.listAttPred[i].azienda : ''),
          cdc: (this.listAttPred.length > i ? this.listAttPred[i].cdc : ''),
          numRiga: ('00' + (i + 1)).slice(-2),
          intervento: (this.listAttPred.length > i ? this.listAttPred[i].intervento : ''),
          km: '0000000'
        }
        this.modalGiorno.righe.push(day)
      }
      this.loading_Day = false
      this.showCalendar = false
      this.modalGiorno.numRows = 8
    },
    saveAttPred: function () {
      let numRighe = 0
      let righe = []
      for (let item of this.modalGiorno.righe) {
        if (item.ore != '0000' && item.causale != '') {
          numRighe++
          let obj = {
            ore: (item.ore != null ? item.ore.valore : ''),
            causale: (item.causale != null ? item.causale.valore : ''),
            localita: (item.localita != null ? item.localita.valore : ''),
            descrLoc: item.descrLoc,
            azienda: (item.azienda != null ? item.azienda.valore : ''),
            cdc: (item.cdc != null ? item.cdc.valore : ''),
            intervento: item.intervento
          }
          righe.push(obj)
        }
      }

      let obj = {
        codFisc: this.searchFilter.employee,
        numRighe: numRighe,
        riga: righe
      }
      this.$http.post('presenze/' + this.$store.state.country + '/attPred', obj).then(response => {
        if (response.body.rc === 0) {
          this.getPresDef()
          this.modalType = ''
          this.showModalDetails = false
        } else {

          for (let i = 0; i < response.body.msg.length; i++) {
            this.$message({
              showClose: true,
              message: response.body.msg[i].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        }
      })
    }
  }
};
</script>


<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/mobile_customize.less";
@import "../../assets/less/el-dialog_mobile";
@import "../../assets/less/el-form_mobile";
@import "@fullcalendar/core/main.css";
@import "@fullcalendar/daygrid/main.css";

.presenza-mobile {
  padding: 0;

  .action {
    height: 20px;
    line-height: 20px;

    span {
      float: right;
      .set-font(@size: 14px, @color: @grayDark, @weight: bold, @family: 'os-regular');
      text-transform: capitalize;
      padding-right: 15px;
    }
  }

  .day-body {
    &.max {
      height: 560px;
    }

    &.min {
      height: 470px;
    }

    .el-carousel-presenze {
      min-height: 470px;

      .el-carousel__container {
        min-height: 430px;

        .el-carousel__item {
          min-height: 430px;
        }
      }

      &.max {
        height: 560px;

        .el-carousel__container {
          height: 520px;

          .el-carousel__item {
            height: 520px;
          }
        }
      }

      &.min {
        height: 470px;

        .el-carousel__container {
          height: 430px;

          .el-carousel__item {
            height: 430px;
          }
        }
      }

      .el-carousel__container {

        //height: 520px;
        .el-carousel__item {
          //height: 520px;
        }
      }
    }
  }

  .el-form-body {
    padding: 0 !important;
    background-color: #fff !important;
    border: none !important;
  }

  .input-wrapper {
    height: 38px;

    input {
      height: 38px;
      width: 100%;
      padding-right: 24px;
      background-color: #fff;
      border-radius: 5px;
      border-color: #969696;
      font-size: 18px;
      text-align: center;
      color: #969696;
      // margin: 3px;
      padding: 3px;
      -webkit-appearance: none;

      &.first {
        float: left;
      }

      &.second {
        float: right;
      }
    }

    .el-input {
      height: 38px;
      width: 100%;
      //padding-right: 24px;
      padding: 0;
      background-color: #fff;
      border-radius: 5px !important;
      border-color: 1px solid #969696 !important;
      font-size: 18px;
      text-align: center;
      color: #969696;
      // margin: 3px;
      //padding: 3px;
      -webkit-appearance: none;

      &.first {
        float: left;
      }

      &.second {
        float: right;
      }

      .el-input-group__prepend {
        border: 1px solid #969696 !important;
      }
    }

    .el-input__inner {
      border: 1px solid #969696 !important;
      border-top-right-radius: 5px !important;
      border-bottom-right-radius: 5px !important;
      border-left: none !important;
      height: 38px !important;
      width: 100%;
      padding-right: 24px;
      background-color: #fff;
      font-size: 18px;
      text-align: center;
      color: #969696;
      // margin: 3px;
      padding: 3px;
      -webkit-appearance: none;

      &.first {
        float: left;
      }

      &.second {
        float: right;
      }
    }
  }

  .select-wrapper {
    position: relative;
    display: inline-block;

    &:after {
      content: '\0025BC';
      // font: normal normal normal 12px/1 FontAwesome;
      color: #cbb385;
      right: 4%;
      top: -7px;
      height: 26px;
      padding: 15px 0px 0px 8px;
      position: absolute;
      pointer-events: none;
    }

    select {
      .set-font(@size: 18px, @weight: bold, @color: @textTable, @family: 'os-bold');
      width: 100%;
      padding-right: 24px;
      background-color: #fff;
      border-radius: 5px;
      border-color: #cbb385;
      //font-family: Arial, ArialHebrew, sans-serif;
      //font-size: 18px;
      text-align: -moz-center;
      text-align: -webkit-center;
      text-align: center !important;
      //color: #cbb385;
      //margin: 3px;
      padding: 3px;
      -webkit-appearance: none;

      &:focus {
        outline: none;
      }
    }
  }

  .fc-header-toolbar {
    .fc-today-button {
      background-color: transparent;
      color: @grayDark;
      border: none;
      text-transform: capitalize;
    }

    .fc-prev-button,
    .fc-next-button {
      background-color: transparent;
      border: none;

      span {
        color: #007c74;
        font-size: 20px;
      }
    }
  }

  .fc-head {
    table {
      border-collapse: separate;
      border-spacing: 3px;

      thead {
        tr {
          th {
            border: none;
          }
        }
      }
    }
  }

  .fc-body {
    .fc-scroller {
      height: 100% !important;

      .fc-day-grid {

        table {
          border-collapse: separate;
          border-spacing: 3px;

          .fc-day-number {
            float: unset;
            display: block;
            text-align: center;
            font-size: 20px;
            font-family: 'os-bold';
            line-height: 35px;
            color: black;
          }
        }

        .fc-highlight-skeleton {
          table {
            tbody {
              tr {
                .fc-highlight {
                  background: none;
                  background-color: rgba(21, 129, 171, 0.25);
                  border: 1px solid rgba(61, 145, 177, 0) !important;
                  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgb(59, 124, 120);
                }
              }
            }
          }
        }

      }

      .fc-bgevent {
        padding-top: 15px;
        color: black;
        background: #fff;

        &.inserita {
          border: none;
          //opacity: 1;
          background: #00a641;
        }

        &.festivo {
          border: none;
          //opacity: 1;
          background: #b3b3b3;
        }

        &.attPred {
          border: none;
          //opacity: 1;
          background: #ffc401;
        }
      }

      background: #fff;
    }
  }
}

.popover-mobile {
  line-height: 50px;
  .set-font(@size: 18px, @color: @grayTesto, @family: "os-semibold");
  min-width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/PresenzeWebMobile/PresenzaMobile.vue